export default "__VITE_ASSET__BCJd9T5k__"